import DeleteTemplateModal from '@/components/TemplateGallery2/DeleteTemplateModal';
import TemplateGallery2 from '@/components/TemplateGallery2/TemplateGallery';
import {
  TemplateGalleryContext,
  useTemplateGalleryContext,
} from '@/hooks/useTemplateGalleryContext';
import { Modal } from '@vibe/core/next';
import React, { useState } from 'react';

type Props = {
  children: React.ReactNode;
};

const TemplateGalleryModal = ({
  templateDeleteConfirmationDialog,
  setTemplateDeleteConfirmationDialog,
}: {
  templateDeleteConfirmationDialog: {
    show: boolean;
    templateId: string;
    isInUse: boolean;
  };
  setTemplateDeleteConfirmationDialog: React.Dispatch<
    React.SetStateAction<{
      show: boolean;
      templateId: string;
      isInUse: boolean;
    }>
  >;
}) => {
  const { isShown, galleryOptions, hideGallery } = useTemplateGalleryContext();

  if (!isShown || !galleryOptions) return null;

  const handleClose = () => {
    hideGallery();
  };

  const handleCloseDeleteTemplateDialog = () => {
    setTemplateDeleteConfirmationDialog({
      show: false,
      templateId: '',
      isInUse: false,
    });
  };
  return (
    <>
      <Modal
        onClose={handleClose}
        show={isShown}
        id="template-gallery-modal"
        className="min-h-[95%]"
        alertModal
      >
        <TemplateGallery2 envelopeId={galleryOptions.envelopeId ?? ''} />
      </Modal>
      <DeleteTemplateModal
        show={templateDeleteConfirmationDialog.show}
        onClose={handleCloseDeleteTemplateDialog}
        templateId={templateDeleteConfirmationDialog.templateId}
        isInUse={templateDeleteConfirmationDialog.isInUse}
      />
    </>
  );
};

export const TemplateGalleryProvider = ({ children }: Props) => {
  const [isShown, setIsShown] = useState(false);
  const [galleryOptions, setGalleryOptions] = useState<{
    envelopeId?: string;
  } | null>(null);

  const [
    templateDeleteConfirmationDialog,
    setTemplateDeleteConfirmationDialog,
  ] = useState({
    show: false,
    templateId: '',
    isInUse: false,
  });

  const showGallery = (options: { envelopeId?: string }) => {
    setGalleryOptions(options);
    setIsShown(true);
  };

  const hideGallery = () => {
    setIsShown(false);
    setGalleryOptions(null);
  };

  const showDeleteTemplateDialog = ({
    templateId,
    isInUse,
  }: {
    templateId: string;
    isInUse: boolean;
  }) => {
    setTemplateDeleteConfirmationDialog({
      show: true,
      templateId,
      isInUse,
    });
  };

  return (
    <TemplateGalleryContext.Provider
      value={{
        showGallery,
        hideGallery,
        isShown,
        galleryOptions,
        showDeleteTemplateDialog,
      }}
    >
      {children}
      <TemplateGalleryModal
        templateDeleteConfirmationDialog={templateDeleteConfirmationDialog}
        setTemplateDeleteConfirmationDialog={
          setTemplateDeleteConfirmationDialog
        }
      />
    </TemplateGalleryContext.Provider>
  );
};

export default TemplateGalleryProvider;
